/**
 * Decimal currency entry. "1200" is twelve hundred dollars, never 12.00.
 * Cents are only applied when the operator types a decimal point.
 */

export function parseMoneyInput(raw: string | number | null | undefined): number | null {
  if (typeof raw === "number") {
    return Number.isFinite(raw) ? roundMoney(raw) : null;
  }
  const s = String(raw ?? "").trim().replace(/[$\s,]/g, "");
  if (!s) return null;
  if (!/^-?\d+(\.\d{0,4})?$/.test(s)) return null;
  const n = Number(s);
  if (!Number.isFinite(n)) return null;
  return roundMoney(n);
}

export function roundMoney(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function formatMoneyPreview(value: number | null, symbol = "A$"): string {
  if (value == null) return `${symbol} —`;
  const abs = Math.abs(value).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${symbol} ${value < 0 ? "-" : ""}${abs}`;
}

export function moneyInputDisplay(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "";
  return String(value);
}
